import React, { useRef } from 'react';

import {
  GET_BUY_MOTOR_POLICY_VAR_DETAILS,
  SAVE_QUOTE_TWO_WHEELER,
} from '../queries';
import { updateBuyMotorPolicy,resetProposerDetails } from 'quanta-flows/modules/proposal/motor/state';
import { ProposerDetails } from 'quanta-flows/modules/common/proposer';
import { useQuery } from '@apollo/client';
export default function ProposerDetailsTwoWheeler({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
  ...props
}) {
  const initLoadRef = useRef([]);
  const {
    loading: loadingBuyMotorPolicy,
    error: errorBuyMotorPolicy,
    data: dataBuyMotorPolicy,
    previousData: previousDataBuyMotorPolicy,
  } = useQuery(GET_BUY_MOTOR_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current)?.size >= 1,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });

  const saveQuoteVariables = ({ lob_code, product_code, values }) => {
    let riskInput = [];
    values?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter(
          (c) => values?.coverData[`addOnCovers`][c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    values?.coverData[`addOnCovers`][`${c?.name}`][
                      `attributes`
                    ][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        quoteNumber: values?.quoteNumber
        ? `${values?.quoteNumber}`
        : '',
        proposalNumber: values?.proposalNumber && values?.isProposalModify
        ? `${values?.proposalNumber}`
        : '',
        quoteCreationDate: values?.quoteCreationDate
        ? `${values?.quoteCreationDate}`
        : '',
        productType: values?.productType,
        productVariant:values?.productVariant,
        businessType: values?.businessType,
        intermediary: {
          intermediaryCode: values?.intermediaryDetails?.code,
          locationCode: values?.intermediaryDetails?.location,
          fieldUserCode: values?.intermediaryDetails?.fieldUserCode,
        },
        customer: values?.proposerDetails,
        lob: '31',
        disableNCB:values?.disableNCB,
        product: values?.productCode
          ? values?.productCode
          : values?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
            && values?.productType?.toLowerCase()?.search('od') === -1
            ? '3121'
            : values?.productVariant?.toLowerCase()?.search('liability') !== -1
              ? '3176'
              : values?.productType?.toLowerCase()?.search('od') !== -1
                ? '3151'
                : productCode,
        location: {
          pinCode: values?.quoteData?.pincode,
          state: values?.quoteData?.state,
        },
        vehicleDetails: {
          make: {
            code: values?.quoteData?.make?.code,
            value: values?.quoteData?.make.value,
          },
          model: {
            code: values?.quoteData?.model?.code,
            value: values?.quoteData?.model?.value,
          },
          variant: {
            code: values?.quoteData?.variant?.code,
            value: values?.quoteData?.variant.value,
          },
          engineNumber: values?.quoteData?.engineNo,
          chasisNumber: values?.quoteData?.chasisNo,
          registrationNumber: values?.quoteData?.regNo,
          manufactureYear: values?.quoteData?.yearOfManufacture,
          regPurchaseDate: values?.quoteData?.dateOfReg,
          fuelType: values?.quoteData?.fuelType,
          seatingCapacity: values?.quoteData?.seatingCapacity,
          cubicCapacity: values?.quoteData?.cubeCapacity,
          segmentType: values?.quoteData?.segmentType,
          vehicleAge: values?.quoteData?.premiumData?.vehicleAge,
          registrationNumberOthers: values?.quoteData?.regNoPart2,
          zoopCustDtls : values?.quoteData?.zoopCustDtls,
        },
        rtoDetails: {
          rtoAuthCode: values?.quoteData?.rtoAuthorityCode,
          rtoLocCode: values?.quoteData?.rtoLocationCode,
          rtoLocDesc: values?.quoteData?.rtoLocationDesc,
        },
        coverDisable: values?.quoteData?.coverDisable == true ? true : false,
        ConcoverDisable: values?.quoteData?.ConcoverDisable == true ? true : false,
        coverRTIDisable: values?.quoteData?.coverRTIDisable == true ? true : false,
        coverEngineeDisable: values?.quoteData?.coverEngineeDisable == true ? true : false,
        TP_Policy_Tenure: values?.quoteData?.TP_Policy_Tenure,
        TP_Start_Date: values?.quoteData?.TP_Start_Date,
        TP_End_Date: values?.quoteData?.TP_End_Date,
        adjustmentIRF2:values?.quoteData?.adjustmentIRF2,
        IRF2comments:values?.quoteData?.IRF2comments,
        isPreviousPolicy:
          values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
          'Yes'
            ? true
            : false,
        previousPolicy: {
          coverType:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyCoverType
              : '',
          policyTenure:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyTenure
              : '',
          insurerName:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.prevInsurance?.insurerName
              : '',
          policyNumber:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.prevInsurance?.policyNumber
              : '',
          startDate:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyStartDate
              : '',
          expiryDate:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.policyExpiryDate
              : '',
        },
        previousClaims: {
          totalClaimCount:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.totalClaimCount
              : '',
          claimsInYear1:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.noOfClaimsOneYear
              : '',
          claimsInYear2:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.noOfClaimsTwoYears
              : '',
          claimsInYear3:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes'
              ? values?.quoteData?.noOfClaimsThreeYears
              : '',
          prevNCBSlab:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes' //&& values?.quoteData?.policyTenure
              ? values?.quoteData?.previousYearNCBSlab
              : '',
          totalClaimAmount:
            values?.quoteData?.anyPreviousPolicyforVehicleTaken ===
            'Yes' //&& values?.quoteData?.policyTenure
              ? values?.quoteData?.totalClaimAmount
                ? parseFloat(values?.quoteData?.totalClaimAmount)
                : null
              : null,
          claimFreeYear:
            values?.quoteData?.premiumData?.claimFreeYear,
        },
        financerName: values?.quoteData?.financerName,
        insuredDeclaredValue: {
          suggestedIDV: values?.quoteData?.suggestedIDV,
          firstYearIDV: values?.quoteData?.changedIDV,
        },
        irf1: values?.quoteData?.adjustmentIRF,
        creditScoreDetials: {
          discountOpted:
            values?.quoteData?.getAdditionalCreditScore === 'Yes'
              ? true
              : false,
          idProofType: values?.quoteData?.idProofType,
          idProofNumber: values?.quoteData?.idProofNumber,
          creditScore: parseFloat(values?.quoteData?.premiumData?.creditScore)
                     || parseFloat(values?.quoteData?.creditScore) ,
          firstName: values?.quoteData?.cs_proposer_first_name,
          lastName: values?.quoteData?.cs_proposer_last_name,
          mobileNo: values?.quoteData?.cs_proposer_mobileNo,
          proposerDOB: values?.quoteData?.cs_proposerDOB,
        },
        coverType: '',
        tenure: values?.coverData?.tenure,
        riskCovers: riskInput,
        premiumBreakup: {
          idvYear1: parseFloat(values?.quoteData?.premiumData?.idv1),
          idvYear2: parseFloat(values?.quoteData?.premiumData.idv2),
          idvYear3: parseFloat(values?.quoteData?.premiumData.idv3),
          netODPremium: parseFloat(
            values?.quoteData?.premiumData?.netODPremium,
          ),
          netTPPremium: parseFloat(
            values?.quoteData?.premiumData?.netTPPremium,
          ),
          loadingDiscount: parseFloat(
            values?.quoteData?.premiumData?.loadingDiscount,
          ),
          netPremium: parseFloat(
            values?.quoteData?.premiumData?.netPremium,
          ),
          gst: parseFloat(values?.quoteData?.premiumData?.gst),
          stampDuty: parseFloat(
            values?.quoteData?.premiumData?.stampDuty,
          ),
          totalPremium: parseFloat(
            values?.quoteData?.premiumData?.totalPremium,
          ),
          NCB: parseFloat(values?.quoteData?.premiumData?.NCB),
          loading: values?.quoteData?.premiumData?.loading
            ? values?.quoteData?.premiumData.loading
            : [],
          discount: values?.quoteData?.premiumData?.discount
              ? values?.quoteData?.premiumData.discount
              : [],
          clutchProtPremium: parseFloat(
            values?.quoteData?.premiumData?.clutchProtPremium
          ),
          clutchProtRate: parseFloat(
            values?.quoteData?.premiumData?.clutchProtRate
          ),
          clutchProtSI: parseFloat(
            values?.quoteData?.premiumData?.clutchProtSI
          ),
        },
        voluntaryDeductibleAmt: parseFloat(
          values?.quoteData?.voluntaryDeductibleAmount,
        ),
        NCB: parseFloat(values?.quoteData?.premiumData?.NCB),
        quotePdf: values?.quoteData?.premiumData?.quotePdf,
        isQuoteSavingWOCust: values?.quoteData?.isQuoteSavingWOCust ,
        QuoteSavingWOCustIndex: values?.quoteData?.isQuoteSavingWOCust ?
          2 : null ,
        policy: {
            startDate: values?.quoteData?.policy?.startDate,
            expiryDate: values?.quoteData?.policy?.expiryDate,
        },
      },
    };
  };

  return (
    <>
      {!loadingBuyMotorPolicy && !errorBuyMotorPolicy && (
        <ProposerDetails
          {...{
            REACTIVE_VAR_QUERY: GET_BUY_MOTOR_POLICY_VAR_DETAILS,
            SAVE_QUOTE_QUERY: SAVE_QUOTE_TWO_WHEELER,
            goToStep,
            proceedToNextStep,
            resetProposerDetails,
            saveQuoteVariables,
            setCustomLoadingMessage,
            setLoadingStep,
            setParentAlerts,
            setProceedToNextStep,
            updateReactiveVar: updateBuyMotorPolicy,
            preCustomerType: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.organisationType,
            preGender: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.vehicleOwnerTypeAndGender?.gender,
            prePermPincode: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.pincode
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.pincode,
            prePermState: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.state
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.state,
            prePermDistrict: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.district,
            prePermCityTownVillage: dataBuyMotorPolicy
              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.city
              : previousDataBuyMotorPolicy?.buyMotorPolicy?.quoteData
                  ?.city,
            ...props,
          }}
        />
      )}
    </>
  );
}
